// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"94661cf8","18":"a78a6407","266":"492890f6","293":"5392154d","388":"25f09003","778":"ab6b13ca","846":"385d7ceb","997":"2a5518cb"}[chunkId] + ".chunk.css";
};